/**
 * Created by pablo on 8/22/17.
 */




// WEBPACK FOOTER //
// ./resources/assets/js/services/invoice_book.js